import styled from 'styled-components'

import {Box, List, ListItem, NakedButton, tokens} from '@pleo-io/telescope'

import {Accordion} from '~/generic-ui/accordion'

export const LinkButton = styled(NakedButton)`
    color: ${tokens.pink800};
    font-size: ${tokens.fontMedium};
`

export const StyledAccordionGuideItem = styled(Accordion.Item)`
    width: 100%;
`

export const StyledAccordionGuideContent = styled(Accordion.Content)`
    width: 260px;
    margin-top: -20px;
`

export const StyledList = styled(List)`
    margin-top: ${tokens.spacing20};
    text-align: left;
`

export const StyledListItem = styled(ListItem)`
    width: 260px;
    list-style-position: outside;
    margin-left: ${tokens.spacing20};
    margin-bottom: ${tokens.spacing2};

    :last-child {
        margin-bottom: 0px;
    }
`

export const LearnMoreBox = styled(Box)`
    margin-top: ${tokens.spacing16};
    border-left: 2px solid ${tokens.pink700};
    background: ${tokens.shade100};
    width: 260px;
    text-align: left;
    padding: ${tokens.spacing8} ${tokens.spacing16};
`
